import { z } from "zod";
import { type ParserType, parser } from "./parser.js";

export type ValidationError = ParserType<typeof ValidationError>;
export const ValidationError = parser(
  z.strictObject({
    error: z.strictObject({
      path: z.string(),
      reason: z.string(),
    }),
  }),
);
